import React from 'react';

const SigninOidc = () => {
    return <div>Redirecting...</div>;
};

export default SigninOidc;
